<template>
    <el-dialog
        class="ssm-match-dialog"
        title="查看匹配结果弹窗"
        :visible.sync="visible"
        :close-on-click-modal="false"
        top="4%"
        width="900px"
        :before-close="close">
        <div>
            <m-pane
                ref="tablePage"
                :config="config"
                :totalData="totalData"
                :pageTotal="page.pageTotal"
                :loading="loading"
                :currentPage="page.pageNo"
                searchId="idleResourceLoadUnloadSearchId"
                :pageID="config.table.pageId"
                @searchChange="searchChange"
                @pageChange="pageChange"
                @sizeChange="sizeChange"
            >
                <div slot="provinceCodeSlot">
                    <el-select v-model="slotSearchObj.provinceCode" :placeholder="provinceholder" clearable @change="handleProvinceChange">
                        <el-option
                            v-for="option in provinceOptions"
                            :key="option.label + '_' +option.value"
                            :label="option.label"
                            :value="option.value"
                        ></el-option>
                    </el-select>
                </div>
                <div slot="cityCodeListSlot">
                    <el-select v-model="slotSearchObj.cityCodeList" :placeholder="cityholder" clearable multiple collapse-tags @change="handleCityChange">
                        <el-option
                            v-for="option in cityOptions"
                            :key="option.label + '_' +option.value"
                            :label="option.label"
                            :value="option.value"
                            multiple
                        ></el-option>
                    </el-select>
                </div>
                <div slot="table-module-btn">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <el-button class="bigData-btn-export" icon="el-icon-download" size="mini" :loading="exportLoading" @click="handleExport"></el-button>
                    </el-tooltip>
                </div>
            </m-pane>
        </div>
    </el-dialog>
</template>
<script>
// import { mapGetters, mapState } from 'vuex';
import dayjs from 'dayjs';
import { searchLoadIdleResourcesMatch, searchWarehouseIdleResourcesMatch, exportMatchResources } from '../../../api/storageSupManage/idleResource.js';
import { getCitys } from '../../../utils/getArea.js'
import mPane from '@/components/supplierPanel';
// import { phoneVerify } from '../../../constant/formRegular.js';
// import MSelect from '@/components/lots/otpSelect2/index.vue';

// 1=装卸闲置资源 2=装卸需求资源 3=仓库闲置资源 4=仓库需求资源
const searchApi = {
    '1': searchLoadIdleResourcesMatch,
    '2': searchLoadIdleResourcesMatch,
    '3': searchWarehouseIdleResourcesMatch,
    '4': searchLoadIdleResourcesMatch,
}

export default {
    components: { mPane },
    props: {
        config: {
            type: Object,
            default: () => ({})
        },
        provinceOptions: {
            type: Array,
            default: () => []
        },
        provinceholder: {
            type: String,
            default: () => '省份'
        },
        cityholder: {
            type: String,
            default: () => '城市'
        },
        businessType: {
            type: String,
            default: () => ''
        },
        dict: {
            type: Object,
            default: () => ({
                SYS_SU_WH_TYPE: {},
            })
        },
    },
    data() {
        return {
            currentId: '',
            visible: false,
            loading: false,
            exportLoading: false,
            totalData: [],
            page: {
                pageNo: 1,
                pageSize: 10,
                pageTotal: 0
            },
            searchObj: {},
            slotSearchObj: {
                provinceCode: '',
                cityCodeList: [],
            },
            cityOptions: [],
        };
    },
    computed: {
        // ...mapState(['supplier']),
        // ...mapGetters(['user', 'currentTenant']),
    },
    methods: {
        open(row) {
            this.visible = true;
            // this.form.contacts = this.supplier ? this.supplier.contacts : this.user.userName
            // this.form.contactNumber = this.supplier ? this.supplier.contactsMobile : this.user.mobile
            if (row) {
                this.currentId = row.id;
                this.getTableData();
            }
        },
        close() {
            this.currentId = '';
            // this.form = { ...INITFORM };
            // this.cityOptions = []
            // this.areaOptions = []
            // this.$nextTick(() => {
            //     this.$refs.form.clearValidate();
            //     this.visible = false;
            // });
            this.totalData = []
            this.page.pageNo = 1
            this.page.pageTotal = 0
            this.slotSearchObj = {
                provinceCode: '',
                cityCodeList: [],
            }
            this.cityOptions = []
            this.visible = false;

        },
        getTableData() {
            this.loading = true
            searchApi[this.businessType](this.getParams()).then(res => {
                if (res && +res.code === 0) {
                    this.page.pageTotal = res.data.totalCount;
                    this.totalData = res.data.list.map(item => {
                        if (item.startTime) {
                            item.startTime = dayjs(item.startTime).format('YYYY-MM-DD')
                        }
                        if (item.endTime) {
                            item.endTime = dayjs(item.endTime).format('YYYY-MM-DD')
                        }
                        if (item.activationDate) {
                            item.activationDate = dayjs(item.activationDate).format('YYYY-MM-DD')
                        }
                        if (item.warehouseType) {
                            item.warehouseType_ = item.warehouseType.split(',').map(item => this.dict.SYS_SU_WH_TYPE[item]).join(',')
                        }
                        return item
                    })
                }
            }).finally(() => { this.loading = false });
        },
        getParams() {
            const params = JSON.parse(JSON.stringify({ ...this.searchObj, ...this.slotSearchObj }));
            params.businessId = this.currentId
            params.businessType = this.businessType
            params.pageNo = this.page.pageNo
            params.pageSize = this.page.pageSize
            if (params.provinceCode) {
                params.provinceCodeList = [params.provinceCode]
            } else {
                params.provinceCodeList = []
            }
            delete params.provinceCode
            return params
        },
        searchChange(data) { // 点击查询
            this.page.pageNo = 1;
            this.getTableData();
        },
        pageChange(pageNo) { // 切换分页页数
            this.page.pageNo = pageNo;
            this.getTableData();
        },
        sizeChange(pageSize) { // 切换分页显示条数
            this.page.pageNo = 1;
            this.page.pageSize = pageSize;
            this.getTableData();
        },
        handleProvinceChange(val) {
            this.slotSearchObj.cityCodeList = []
            this.cityOptions = [];
            getCitys(val).then(res => {
                this.cityOptions = res;
            })
        },
        handleCityChange(val) {},
        handleExport() {
            const params = this.getParams()
            delete params.pageNo
            delete params.pageSize
            this.exportLoading = true
            exportMatchResources(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(res.data || '正在导出，请留意右上角文件中心下载文件！');
                }
            }).finally(() => { this.exportLoading = false });
        },
    },
    // mounted() {
    //     dictWithUrl('SYS_BUSINESS_CATEGORY').then(res => {
    //         if (res && +res.code === 0) {
    //             this.dictData = res.data;
    //             this.obtValueList = Object.keys(this.dictData.SYS_BUSINESS_CATEGORY)
    //         }
    //     })
    // }
};
</script>
<style lang="less">
.ssm-match-dialog {
    #mPane3 div.el-table {
        min-height: auto;
    }

    .row-bg {
        .page-text {
            width: 0%;
        }
        .el-col-12:last-of-type {
            width: 100%;
            max-width: unset !important;
            flex: unset !important;
        }
    }
}
</style>